import React from 'react';

const HowItWorks = () => {
  // Função para criar o link do WhatsApp
  const createWhatsAppLink = (message) => {
    const phoneNumber = "5537998630380";
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  };

  const steps = [
    {
      number: "01",
      title: "Avaliação Inicial Profunda",
      description: "Mapeamento completo de sua história emocional, padrões relacionais e estruturas psíquicas inconscientes que moldam suas escolhas.",
      duration: "1-2 sessões",
      details: [
        "Análise de padrões familiares e relacionais",
        "Identificação de traumas e crenças limitantes",
        "Mapeamento de mecanismos de defesa",
        "Avaliação de recursos internos disponíveis"
      ]
    },
    {
      number: "02", 
      title: "Mapeamento de Padrões Inconscientes",
      description: "Identificação precisa dos automatismos emocionais e comportamentais que se repetem em diferentes contextos de sua vida.",
      duration: "2-3 sessões",
      details: [
        "Reconhecimento de gatilhos emocionais",
        "Análise de ciclos repetitivos",
        "Compreensão das funções dos sintomas",
        "Identificação de ganhos secundários"
      ]
    },
    {
      number: "03",
      title: "Desconstrução de Crenças Limitantes", 
      description: "Processo gradual de questionamento e dissolução das estruturas mentais que sustentam os padrões disfuncionais.",
      duration: "4-6 sessões",
      details: [
        "Questionamento de verdades absolutas",
        "Ressignificação de experiências passadas",
        "Dissolução de vínculos traumáticos",
        "Liberação de culpas e ressentimentos"
      ]
    },
    {
      number: "04",
      title: "Reconstrução da Identidade Emocional",
      description: "Desenvolvimento de uma nova estrutura psíquica baseada em escolhas conscientes e valores autênticos.",
      duration: "6-8 sessões", 
      details: [
        "Construção de nova autoimagem",
        "Desenvolvimento de recursos internos",
        "Estabelecimento de limites saudáveis",
        "Criação de novos padrões relacionais"
      ]
    },
    {
      number: "05",
      title: "Integração e Autonomia",
      description: "Consolidação das mudanças e desenvolvimento da capacidade de manter a transformação de forma independente.",
      duration: "2-4 sessões",
      details: [
        "Integração das novas estruturas",
        "Desenvolvimento de autonomia emocional",
        "Estratégias de manutenção",
        "Preparação para desafios futuros"
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 relative">
              Como funciona o processo de reconstrução emocional
              <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-red-600 mt-2"></span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Um processo estruturado e científico, desenvolvido ao longo de mais de 2 mil atendimentos, 
              para transformação profunda e duradoura.
            </p>
          </div>

          <div className="space-y-8">
            {steps.map((step, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="md:flex">
                  <div className="md:w-1/4 bg-gradient-to-br from-red-600 to-red-800 text-white p-8 flex flex-col justify-center items-center">
                    <div className="text-4xl font-bold mb-4">{step.number}</div>
                    <div className="text-center">
                      <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                      <div className="text-sm bg-red-500 px-3 py-1 rounded-full">
                        {step.duration}
                      </div>
                    </div>
                  </div>
                  
                  <div className="md:w-3/4 p-8">
                    <p className="text-lg text-gray-700 mb-6">
                      {step.description}
                    </p>
                    
                    <div className="grid md:grid-cols-2 gap-4">
                      {step.details.map((detail, detailIndex) => (
                        <div key={detailIndex} className="flex items-start">
                          <span className="text-red-600 mr-3 mt-1">•</span>
                          <span className="text-gray-600">{detail}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-black text-white p-8 rounded-lg text-center">
            <h3 className="text-2xl font-bold mb-4">
              Tempo médio do processo completo
            </h3>
            <p className="text-3xl font-bold text-red-400 mb-4">
              6 a 12 meses
            </p>
            <p className="text-lg text-gray-300 mb-8">
              A duração varia conforme a complexidade de cada caso e o ritmo individual de cada pessoa. 
              O importante não é a velocidade, mas a profundidade e sustentabilidade da transformação.
            </p>
            
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <a 
                href={createWhatsAppLink("Olá, gostaria de saber mais sobre o processo de reconstrução emocional e agendar uma avaliação inicial.")} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-accent text-lg px-8 py-4"
              >
                QUERO INICIAR MINHA JORNADA
              </a>
              <a 
                href={createWhatsAppLink("Olá, gostaria de esclarecer algumas dúvidas sobre o processo terapêutico.")} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn text-lg px-8 py-4 bg-transparent border border-white text-white hover:bg-white hover:text-black transition-all duration-300"
              >
                ESCLARECER DÚVIDAS
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;

